// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  color: #ff3d71;
}

.headerActions > div > a,
.dropdownContainer > .dropdown-toggle {
  padding: 0 10px 0;
}

.errorIcon::before {
  font-family: 'icomoon';
  content: '\\e93e';
}

.errorStepText {
  border-color: #ff3d71;
  color: #ff3d71;
  font-size: 1.5rem;
  cursor: pointer;
  font-style: normal;
  font-family: 'montserratbold';
  padding: 0 0.5rem !important;
  margin: 0.61rem 2rem 0;
  /* line-height: 2; */
  position: absolute;
  right: 0;
  z-index: 1;
}

.toastPosition {
  z-index: 11 !important;
  right: 0;
  top: 45px;
  width: 5rem;
  height: 28px;
}

.errorToastPosition {
  z-index: 11 !important;
  right: 0;
  top: 75%;
}

.toast-close {
  position: absolute;
  right: 10px;
}

.toast-body {
  cursor: pointer;
}

@media only screen and (max-width: 900px) and (min-width: 600px) {
  .errorToastPosition {
    top: 82%;
  }
}

@media only screen and (max-width: 1025px) and (min-width: 800px) {
  .errorToastPosition {
    top: 88%;
  }
}
@media only screen and (max-width: 500px) and (min-width: 341px) {
  .errorToastPosition {
    top: 78%;
  }
}
@media only screen and (max-width: 340px) and (min-width: 300px) {
  .errorToastPosition {
    top: 65%;
  }
}
@media only screen and (max-width: 300px) {
  .errorToastPosition {
    top: 45%;
  }
}
/***** Progress bar of StepsList should wrap Css starts here - Modified by Snehal Jadhav *****/
/* .nextStep {
  width: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
/***** Progress bar of StepsList should wrap Css ends here - Modified by Snehal Jadhav *****/

/***** Tooltip for displaying info starts here *****/
/* .tooltip-label-info-container {
  min-width: 250px;
  width: 100%;
  max-width: 300px;
  min-height: 50px;
  font-size: 0.99rem;
  line-height: 1.2;
  text-align: left;
  padding: 5px;
  font-weight: 200;
  white-space: normal;
  font-style: normal;
  background: rgb(234 234 79 / 50%);
}

.tooltip-label-info {
  font-size: 1.2rem;
  color: #317d03;
  position: relative;
  white-space: normal;
  font-style: normal;
  line-height: 0;
  margin-left: 9px;
}

.tooltip-label-info:before {
  content: '\\f29c';
  font-family: 'FontAwesome';
} */
/***** Tooltip for displaying info ends here *****/

.nav-tabs-max-width {
  max-width: 80%;
}

/* Added by Emmanuel Pinto */
/* StepList center alignment start here */
.stepHeader {
  display: flex;
  justify-content: center; /* Center the contents horizontally */
  align-items: center; /* Vertically align items if needed */
  width: 100%; /*stepHeader takes full width */
}

.stepHeader .nav {
  flex-grow: 1; /* This ensures stepList takes only the space it needs */
  text-align: center; /* Center align stepList */
}
/* StepList center alignment end here */
`, "",{"version":3,"sources":["webpack://./src/app/system-common/page-container/page-container.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA,8FAA8F;AAC9F;;;;;GAKG;AACH,4FAA4F;;AAE5F,oDAAoD;AACpD;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;AACH,kDAAkD;;AAElD;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B,yCAAyC;AACzC;EACE,aAAa;EACb,uBAAuB,EAAE,qCAAqC;EAC9D,mBAAmB,EAAE,qCAAqC;EAC1D,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,YAAY,EAAE,wDAAwD;EACtE,kBAAkB,EAAE,0BAA0B;AAChD;AACA,uCAAuC","sourcesContent":[".error {\r\n  color: #ff3d71;\r\n}\r\n\r\n.headerActions > div > a,\r\n.dropdownContainer > .dropdown-toggle {\r\n  padding: 0 10px 0;\r\n}\r\n\r\n.errorIcon::before {\r\n  font-family: 'icomoon';\r\n  content: '\\e93e';\r\n}\r\n\r\n.errorStepText {\r\n  border-color: #ff3d71;\r\n  color: #ff3d71;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  font-style: normal;\r\n  font-family: 'montserratbold';\r\n  padding: 0 0.5rem !important;\r\n  margin: 0.61rem 2rem 0;\r\n  /* line-height: 2; */\r\n  position: absolute;\r\n  right: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.toastPosition {\r\n  z-index: 11 !important;\r\n  right: 0;\r\n  top: 45px;\r\n  width: 5rem;\r\n  height: 28px;\r\n}\r\n\r\n.errorToastPosition {\r\n  z-index: 11 !important;\r\n  right: 0;\r\n  top: 75%;\r\n}\r\n\r\n.toast-close {\r\n  position: absolute;\r\n  right: 10px;\r\n}\r\n\r\n.toast-body {\r\n  cursor: pointer;\r\n}\r\n\r\n@media only screen and (max-width: 900px) and (min-width: 600px) {\r\n  .errorToastPosition {\r\n    top: 82%;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1025px) and (min-width: 800px) {\r\n  .errorToastPosition {\r\n    top: 88%;\r\n  }\r\n}\r\n@media only screen and (max-width: 500px) and (min-width: 341px) {\r\n  .errorToastPosition {\r\n    top: 78%;\r\n  }\r\n}\r\n@media only screen and (max-width: 340px) and (min-width: 300px) {\r\n  .errorToastPosition {\r\n    top: 65%;\r\n  }\r\n}\r\n@media only screen and (max-width: 300px) {\r\n  .errorToastPosition {\r\n    top: 45%;\r\n  }\r\n}\r\n/***** Progress bar of StepsList should wrap Css starts here - Modified by Snehal Jadhav *****/\r\n/* .nextStep {\r\n  width: 44px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n} */\r\n/***** Progress bar of StepsList should wrap Css ends here - Modified by Snehal Jadhav *****/\r\n\r\n/***** Tooltip for displaying info starts here *****/\r\n/* .tooltip-label-info-container {\r\n  min-width: 250px;\r\n  width: 100%;\r\n  max-width: 300px;\r\n  min-height: 50px;\r\n  font-size: 0.99rem;\r\n  line-height: 1.2;\r\n  text-align: left;\r\n  padding: 5px;\r\n  font-weight: 200;\r\n  white-space: normal;\r\n  font-style: normal;\r\n  background: rgb(234 234 79 / 50%);\r\n}\r\n\r\n.tooltip-label-info {\r\n  font-size: 1.2rem;\r\n  color: #317d03;\r\n  position: relative;\r\n  white-space: normal;\r\n  font-style: normal;\r\n  line-height: 0;\r\n  margin-left: 9px;\r\n}\r\n\r\n.tooltip-label-info:before {\r\n  content: '\\f29c';\r\n  font-family: 'FontAwesome';\r\n} */\r\n/***** Tooltip for displaying info ends here *****/\r\n\r\n.nav-tabs-max-width {\r\n  max-width: 80%;\r\n}\r\n\r\n/* Added by Emmanuel Pinto */\r\n/* StepList center alignment start here */\r\n.stepHeader {\r\n  display: flex;\r\n  justify-content: center; /* Center the contents horizontally */\r\n  align-items: center; /* Vertically align items if needed */\r\n  width: 100%; /*stepHeader takes full width */\r\n}\r\n\r\n.stepHeader .nav {\r\n  flex-grow: 1; /* This ensures stepList takes only the space it needs */\r\n  text-align: center; /* Center align stepList */\r\n}\r\n/* StepList center alignment end here */\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
